export const common = {
  siteName: 'Kakobuy Spreadsheet',
  tagline: 'Best Kakobuy Spreadsheet 2026',
  nav: {
    home: 'Strona Główna',
    guide: 'Przewodnik',
    best2026: 'Best 2026',
    articles: 'Artykuły',
  },
  hero: {
    title: 'Kakobuy Spreadsheet Polska',
    subtitle: 'Best Kakobuy Spreadsheet 2026',
    description: 'Odkryj najlepsze listy produktów, przewodniki i porównania dla polskich użytkowników Kakobuy.',
    ctaSpreadsheet: 'kakobuy spreadsheet',
    ctaBuy: 'buy it now',
  },
  categories: {
    title: 'Wybierz kategorię',
    placeholder: 'Wybierz kategorię',
    viewAll: 'Zobacz wszystkie produkty',
  },
  articles: {
    title: 'Poradniki i Artykuły',
    subtitle: 'Najlepsze przewodniki Kakobuy Spreadsheet dla Ciebie',
    readMore: 'Czytaj więcej',
  },
  review: {
    label: 'Recenzja 2026',
    title1: 'Kakobuy Spreadsheet',
    title2: 'to Najlepszy Wybór dla Polski',
    quote: 'Kakobuy Spreadsheet Polska to najlepszy sposób na znalezienie produktów na Kakobuy. Best Kakobuy Spreadsheet 2026 oferuje aktualne listy, porównania i rekomendacje dla użytkowników z Polski.',
    author: 'Ekspert KakoBuy',
  },
  cta: {
    title: 'Odkryj najlepszy Kakobuy Spreadsheet dla Polski i kup teraz',
    button: 'Przejdź do kakobuy spreadsheet',
  },
  footer: {
    subscribe: 'Zapisz się',
    subscribeDesc: 'Otrzymuj najnowsze aktualizacje i nowe arkusze bezpośrednio na swoją skrzynkę.',
    emailPlaceholder: 'Wpisz email',
    subscribeBtn: 'Zapisz się',
    navigation: 'Nawigacja',
    contact: 'Kontakt',
    email: 'kontakt@kakobuyspreadsheet.wtf',
    address: 'Adres',
    addressLine1: 'ul. Przykładowa 123',
    addressLine2: '00-001 Warszawa, Polska',
    copyright: '© 2026 Kakobuy Spreadsheet Polska. Wszelkie prawa zastrzeżone.',
    privacy: 'Polityka prywatności',
    terms: 'Regulamin',
  },
  featured: {
    title: 'Najlepsze Kategorie',
  },
};